import { useFlags } from 'launchdarkly-react-client-sdk';

const DEFAULT_LIMIT = 1500;

export const usePaymentAmountLimit = () => {
    const { maxTransactionAmount } = useFlags();
    const limit: number =
        maxTransactionAmount > 0 ? Number(maxTransactionAmount) : DEFAULT_LIMIT;

    const exceedsLimit = (amount: number | string | undefined): boolean => {
        if (!amount) return false;
        return Number(amount) > limit;
    };

    const limitMessage = `Amount cannot exceed $${limit.toLocaleString('en-CA')} CAD`;
    const listingLimitMessage = `We do not support listings for rent amount above $${limit.toLocaleString('en-CA')} CAD at this time`;

    return { limit, exceedsLimit, limitMessage, listingLimitMessage };
};
